import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Base64 } from 'js-base64';
import Table from 'react-bootstrap/Table';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Loader from '../components/loader/Loader';
import { currentDateFormat } from '../utils';
import { GET_SERVICE_AUTH_BY_PASSENGER } from '../constant';

function ServiceAuthorizationList() {
  const location = useLocation();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate] = useState(new Date());
  const [saList, setSaList] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const encodedProfileId = queryParams.get('profilId');
  const profileId = encodedProfileId ? Base64.decode(encodedProfileId) : null;
  const { passengerName, passengerId, payerId } = location.state ?? {};
  const effectivePassengerId = passengerId ?? profileId;

  useEffect(() => {
    const fetchList = async () => {
      if (!effectivePassengerId) {
        setSaList([]);
        return;
      }
      setLoadingList(true);
      try {
        const response = await axios.get(
          `${GET_SERVICE_AUTH_BY_PASSENGER}/${effectivePassengerId}`
        );
        if (response?.data?.status === '200' && Array.isArray(response?.data?.data)) {
          setSaList(response.data.data);
        } else {
          setSaList([]);
        }
      } catch (error) {
        console.error('Error fetching service authorization list:', error);
        setSaList([]);
      } finally {
        setLoadingList(false);
      }
    };
    fetchList();
  }, [effectivePassengerId]);

  const formatDate = (val) => {
    if (!val) return '—';
    if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}/.test(val)) {
      const d = new Date(val);
      return isNaN(d.getTime()) ? val : d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    }
    return val;
  };

  return (
    <>
      <div className="tab-pane fade active show" id="service-authorization-list" role="tabpanel">
        <section>
          <div className="d-flex justify-content-between form-container align-items-center">
            <div>
              <h2 className="fs-5 fw-semibold">Service Authorization List</h2>
              {passengerName && (
                <Link
                  to={`/home/passenger/profile/id?profilId=${encodedProfileId ?? ''}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="small text-muted text-decoration-none"
                >
                  Passenger: {passengerName}
                </Link>
              )}
            </div>
            <div className="d-flex flex-column align-items-end gap-1">
              <span>{currentDateFormat(currentDate)}</span>
              <button
                type="button"
                className="btn btn-success rounded-1 btn-sm"
                onClick={() => navigate(`/home/passenger/service-authorization/add?profilId=${encodedProfileId || ''}`, { state: { passengerName, passengerId, payerId } })}
              >
                Add Service Authorization
              </button>
            </div>
          </div>

        </section>
        <div className="container-fluid px-mobile-2 bg-white p-0 border-0">
          <Table striped bordered hover className="tbl-require">
            <thead>
              <tr>
                <th><b>#</b></th>
                <th><b>SA Number</b></th>
                <th><b>Service Type</b></th>
                <th><b>Start Date</b></th>
                <th><b>End Date</b></th>
                <th><b>SA Status</b></th>
                <th><b>Base Code</b></th>
                <th><b>Mileage Code</b></th>
                {/* <th><b>Modifier</b></th> */}
                <th><b>Action</b></th>
              </tr>
            </thead>
            <tbody>
              {loadingList ? (
                <tr>
                  <td colSpan={11} className="text-center text-muted py-4">
                    Loading...
                  </td>
                </tr>
              ) : saList.length === 0 ? (
                <tr>
                  <td colSpan={12} className="text-center text-muted py-4">
                    No service authorizations found.
                  </td>
                </tr>
              ) : (
                saList.map((row, index) => {
                  const saStatus = row.status?.name ?? row.sa_status ?? row.saStatus ?? '';
                  const statusLower = String(saStatus).toLowerCase();
                  return (
                    <tr key={row.id ?? index}>
                      <td>{index + 1}</td>
                      <td>{row.sa_number ?? row.saNumber ?? '—'}</td>
                      <td>{row.serviceType?.service_name ?? row.sa_type ?? row.saType ?? '—'}</td>
                      <td>{formatDate(row.start_date ?? row.startDate)}</td>
                      <td>{formatDate(row.end_date ?? row.endDate)}</td>
                      <td
                        className={
                          statusLower === 'active'
                            ? 'text-success fw-bold'
                            : statusLower === 'inactive'
                              ? 'text-secondary fw-bold'
                              : statusLower === 'expired'
                                ? 'text-danger fw-bold'
                                : ''
                        }
                      >
                        {saStatus || '—'}
                      </td>
                      <td>
                        {row?.serviceType?.base_code ?? row?.serviceType?.base_code ?? '—'} {row?.serviceType?.modifier ?? row?.serviceType?.modifier ?? '—'}
                        <br />
                        <small style={{ fontSize: "13px", fontWeight: "600", color: "#0047AB" }}>Rate: {row?.nemtServiceRate?.base_bill_rate ?? '—'} </small>
                        <br />
                        <small className="text-success" style={{ fontSize: "13px", fontWeight: "600" }}>Available Unit: {row?.base_code_available_unit ?? '—'} </small>
                        <br />
                        <small className="text-danger" style={{ fontSize: "13px", fontWeight: "600" }}>Remaining Unit: {row?.remaining_base_code_unit ?? '—'} </small>
                      </td>
                      <td>
                        {row?.serviceType?.milage_code ?? row?.serviceType?.milage_code ?? '—'} {row?.serviceType?.milage_modifier ?? row?.serviceType?.milage_modifier ?? '—'}
                        <br />
                        <small style={{ fontSize: "13px", color: "#0047AB", fontWeight: "600" }}>Rate: {row?.nemtServiceRate?.mileage_bill_rate ?? '—'} </small>
                        <br />
                        <small className="text-success" style={{ fontSize: "13px", fontWeight: "600" }}>Available Unit: {row?.mileage_code_available_unit ?? '—'} </small>
                        <br />
                        <small className="text-danger" style={{ fontSize: "13px", fontWeight: "600" }}>Remaining Unit: {row?.remaining_mileage_code_unit ?? '—'} </small>
                      </td>

                      {/* <td>{row?.serviceType?.modifier ?? row?.serviceType?.modifier ?? 'None'}</td> */}
                      <td>
                        <i
                          className="pi pi-pen-to-square icon-btn-edit cursor-pointer"
                          title="Edit Service Authorization"
                          style={{ fontSize: "13px" }}
                          onClick={() =>
                            navigate(
                              `/home/passenger/service-authorization/edit/${row.id}?profilId=${encodedProfileId || ''}`,
                              {
                                state: { passengerName, passengerId: effectivePassengerId, payerId },
                              }
                            )
                          }
                        >
                        </i>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {(loading || loadingList) && <Loader />}
    </>
  );
}

export default ServiceAuthorizationList;
